export default __webpack_public_path__ + "static/media/36-Building-and-Construction-expo.f25a7344.jpg";